import React, { useState, useEffect } from "react";
import { Box, Select, MenuItem, Typography } from "@mui/material";
import Input from "../components/Input";
import { getUser, updateProfile } from "../api/user";
import { colors, USER_DATA } from "../utils/constants";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ButtonLoading from "../components/ButtonLoading";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ddiOptions = [
  { code: "55", label: "🇧🇷" },
  { code: "351", label: "🇵🇹" },
  { code: "1", label: "🇺🇸" },
  { code: "44", label: "🇬🇧" },
];

export default function Profile() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [ddi, setDdi] = useState("");
  const [whatsapp, setWhatsapp] = useState("");

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    const userData = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
    const userId = userData.uid;

    if (!userId) return;

    await getUser(userId).then((response: any) => {
      setName(response.name);
      setEmail(response.email);
      setWhatsapp(response.whatsapp);
      setDdi(response.ddi || "55");
    });
  };

  const handleSave = () => {
    if (!name || !email || !whatsapp || !ddi || whatsapp == "(") {
      toast.error("Preencha todos os campos");
      return;
    }

    const data = { name, email, ddi, whatsapp };
    const userData = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
    const userId = userData.uid;

    updateProfile(userId, data).then((response) => {
      toast.success("Perfil atualizado com sucesso");

      console.log("response: ", response);

      localStorage.setItem(USER_DATA, JSON.stringify(response));
    });
  };

  const formatPhone = (value: string) => {
    if (value == "(" || !value) {
      return "";
    }

    const cleaned = value.replace(/\D/g, "").slice(0, 11);
    if (ddi === "55") {
      if (cleaned.length <= 2) return `(${cleaned}`;
      if (cleaned.length <= 6)
        return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
      if (cleaned.length <= 10)
        return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(
          6
        )}`;
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(
        7,
        11
      )}`;
    }
    return cleaned;
  };

  const handleChangeWhatsapp = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/\D/g, "");
    setWhatsapp(rawValue);
  };

  let navigate = useNavigate();

  return (
    <Box style={styles.container}>
      <Box style={styles.centerColumn}>
        <Box
          onClick={() => navigate(-1)}
          style={styles.backWrap}
          className="landing-hover-lift"
        >
          <Typography style={styles.back} className="back">
            <ArrowBackIcon sx={{ fontSize: 18 }} /> Voltar para eventos
          </Typography>
        </Box>

        <Box style={styles.card}>
          <span style={styles.title}>Meu Perfil</span>
          <span style={styles.subtitle}>
            Atualize suas informações de contato
          </span>

          <Input
            title="NOME"
            placeholder="Digite seu nome"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <Input
            title="EMAIL"
            placeholder="Digite seu e-mail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <Box style={styles.phoneRow}>
            <Box style={styles.ddiWrap}>
              <Typography
                component="span"
                variant="subtitle2"
                sx={styles.fieldLabel}
              >
                DDI
              </Typography>
              <Select
                value={ddi}
                onChange={(e) => setDdi(e.target.value)}
                sx={{ borderRadius: "8px", width: "100%" }}
              >
                {ddiOptions.map((option) => (
                  <MenuItem key={option.code} value={option.code}>
                    {option.code} ({option.label})
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <Box style={styles.whatsappWrap}>
              <Input
                title="WHATSAPP"
                placeholder="Número de Whatsapp"
                value={formatPhone(whatsapp)}
                onChange={handleChangeWhatsapp}
                type="tel"
                required
              />
            </Box>
          </Box>

          <ButtonLoading
            label="Salvar alterações"
            onClick={handleSave}
            className="landing-hover-lift"
            style={styles.saveButton}
          />
        </Box>
      </Box>
    </Box>
  );
}

const styles: any = {
  container: {
    paddingTop: 100,
    paddingBottom: 60,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  centerColumn: {
    width: "100%",
    maxWidth: 480,
    display: "flex",
    flexDirection: "column",
  },

  backWrap: {
    width: "fit-content",
    cursor: "pointer",
    marginBottom: 24,
  },

  back: {
    fontSize: 14,
    fontWeight: 600,
    color: colors.primary,
    alignItems: "center",
    display: "flex",
    gap: 6,
  },

  card: {
    backgroundColor: colors.white,
    border: "1.5px solid #E5E9F0",
    borderRadius: 20,
    boxShadow: "0 10px 24px -16px rgba(20,33,61,.16)",
    padding: "40px 36px",
    display: "flex",
    flexDirection: "column",
  },

  title: {
    fontSize: 22,
    fontWeight: 700,
    color: "#14213D",
  },

  subtitle: {
    fontSize: 14,
    color: "#5B6472",
    marginTop: 4,
    marginBottom: 8,
    display: "block",
  },

  fieldLabel: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#9FA2B4",
    display: "flex",
  },

  phoneRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    gap: 8,
    width: "100%",
  },

  ddiWrap: {
    width: 110,
    flexShrink: 0,
  },

  whatsappWrap: {
    flex: 1,
  },

  saveButton: {
    marginTop: 28,
    width: "100%",
    height: 52,
    borderRadius: 100,
  },
};
